export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/chat.worker.9759073e.worker.js");
}
